<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Permission</h4>
            <div v-if="action !== 'new'" class="form-group row mb-4">
              <label class="col-form-label col-lg-2">ID</label>
              <label class="col-form-label col-lg-8">{{
                createModel.id
              }}</label>
            </div>
            <b-tabs pills justified content-class="p-3 text-muted">
              <b-tab active class="border-0">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Manaul</span>
                </template>
                <validationObserver ref="addPermissionForm" tag="form" v-slot="{ handleSubmit }">
                  <form @submit.prevent="handleSubmit(onSubmitManual)" @keydown.enter.prevent>
                    <div class="form-group row mb-4">
                      <label class="col-form-label col-lg-2"
                        >Display Name</label
                      >
                      <div class="col-lg-8">
                        <validationProvider
                          v-slot="{ errors }"
                          ref="displayname"
                          name="Display Name"
                          :rules="{
                            required: true,
                            duplicateName: [
                              isDuplicate,
                              'ชื่อ Permission Name ซ้ำกับในระบบ',
                            ],
                          }"
                        >
                          <input
                            id="intput_displayname"
                            name="intput_displayname"
                            type="text"
                            class="form-control"
                            v-model="createModel.display_name"
                            :class="{
                              'is-invalid': errors && errors.length,
                              'is-valid':
                                !(errors && errors.length) &&
                                createModel.display_name,
                            }"
                            v-on:keyup="onValidateDisplayname($event)"
                          />
                          <div
                            v-if="errors && errors.length"
                            class="invalid-feedback"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                    </div>
                    <div class="form-group row mb-4">
                      <label class="col-form-label col-lg-2">Action</label>
                      <div class="col-lg-8">
                        <validationProvider
                          v-slot="{ errors }"
                          ref="action"
                          name="Action"
                          :rules="{ required: true }"
                        >
                          <input
                            id="intput_action"
                            name="intput_action"
                            type="text"
                            class="form-control"
                            v-model="createModel.action"
                            :class="{ 'is-invalid': errors && errors.length }"
                          />
                          <div
                            v-if="errors && errors.length"
                            class="invalid-feedback"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                    </div>
                    <div class="form-group row mb-4">
                      <label class="col-form-label col-lg-2">Method</label>
                      <div class="col-lg-8">
                        <validationProvider
                          v-slot="{ errors }"
                          ref="method"
                          name="Method"
                          :rules="{ required: true }"
                        >
                          <select
                            class="form-control"
                            id="intput_method"
                            name="intput_method"
                            v-model="createModel.method"
                            :class="{ 'is-invalid': errors && errors.length }"
                          >
                            <option value="">Please select one</option>
                            <option value="read">Read</option>
                            <option value="update">Update</option>
                            <option value="create">Create</option>
                            <option value="delete">Delete</option>
                            <option value="reverse">Reverse</option>
                            <option value="userdefine">User Define</option>
                          </select>
                          <div
                            v-if="errors && errors.length"
                            class="invalid-feedback"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                    </div>
                    <div class="form-group row mb-4">
                      <label class="col-form-label col-lg-2"
                        >Category (controller)</label
                      >
                      <div class="col-lg-8">
                        <validationProvider
                          v-slot="{ errors }"
                          ref="controller"
                          name="Category"
                          :rules="{ required: true }"
                        >
                          <input
                            id="intput_controller"
                            name="intput_controller"
                            type="text"
                            class="form-control"
                            v-model="createModel.controller"
                            :class="{ 'is-invalid': errors && errors.length }"
                          />
                          <div
                            v-if="errors && errors.length"
                            class="invalid-feedback"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                    </div>
                    <div class="form-group row mb-4">
                      <label class="col-form-label col-lg-2"
                        >Version </label
                      >
                      <div v-if="isVersion" class="col-lg-2">
                        <validationProvider
                          v-slot="{ errors }"
                          ref="version"
                          name="Version"
                          :rules="{ required: true }"
                        >
                          <NumberInputSpinner
                            id="intput_version"
                            :step="1"
                            name="intput_version"
                            :class="{ 'is-invalid': errors && errors.length }"
                            :min="1"
                            :max="10"
                            :integerOnly="true"
                            v-model="createModel.version"
                          />
                          <div
                            v-if="errors && errors.length"
                            class="invalid-feedback"
                          >
                            <span>{{ errors[0] }}</span>
                          </div>
                        </validationProvider>
                      </div>
                    </div>
                    <div class="form-group row mb-4">
                      <label class="col-form-label col-lg-2">Area</label>
                      <div class="col-lg-8">
                        <input
                          id="intput_area"
                          name="intput_area"
                          type="text"
                          class="form-control"
                          v-model="createModel.area"
                        />
                      </div>
                    </div>
                    <div class="form-group row mb-4">
                      <label class="col-form-label col-lg-2"
                        >Category Group</label
                      >
                      <div class="col-lg-8">
                        <input
                          id="intput_create_flag"
                          name="intput_create_flag"
                          type="text"
                          class="form-control"
                          v-model="createModel.create_flag"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-form-label col-lg-2">Status</label>
                      <div class="col-form-label col-lg-8">
                        <div class="row col-lg-12">
                          <b-form-radio
                            v-model="createModel.status"
                            name="status"
                            class="custom-control custom-radio custom-radio-info mb-3"
                            value="Active"
                            style="margin-right: 10px"
                            >Active</b-form-radio
                          >
                          <b-form-radio
                            v-model="createModel.status"
                            name="status"
                            class="custom-control custom-radio custom-radio-info mb-3"
                            value="Inactive"
                            style="margin-right: 10px"
                            >Inactive</b-form-radio
                          >
                        </div>
                      </div>
                    </div>
                    <div class="form-group mb-4 text-center">
                      <div class="button-items">
                        <button type="submit" class="btn btn-primary" >
                          Save
                        </button>
                        <button type="reset" class="btn btn-secondary" @click="resetForm">
                          Reset
                        </button>
                        <button
                          type="button"
                          class="btn btn-secondary"
                          @click="onCancel()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </form>
                </validationObserver>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Open API</span>
                </template>
                <validationObserver ref="syncPermissionForm" tag="form">
                  <form @submit.prevent="onSubmitSync">
                    <div class="row">
                      <div class="col-12">
                        <div
                          v-for="(data, index) in apisData"
                          :key="index"
                          class="inner mb-3 row"
                        >
                          <div class="col-md-8 col-6">
                            <validationProvider
                              :vid="`api_url_${index}`"
                              v-slot="{ errors }"
                              name="Swagger uri"
                              :rules="{ required: true, url: true }"
                            >
                              <input
                                v-model="data.api_url"
                                type="text"
                                class="inner form-control"
                                placeholder="Enter api swagger,open api..."
                                :class="{
                                  'is-invalid': errors && errors.length,
                                  'is-valid':
                                    !(errors && errors.length) && data.api_url,
                                }"
                              />
                              <div
                                v-if="errors && errors.length"
                                class="invalid-feedback"
                              >
                                <span>{{ errors[0] }}</span>
                              </div>
                            </validationProvider>
                          </div>
                          <div class="col-md-3 col-4">
                            <b-form-group>
                              <multiselect
                                v-model="data.display_name_field"
                                label="key"
                                placeholder="Please select display name"
                                :options="display_name_field_options"
                                :allow-empty="false"
                              >
                                <template
                                  slot="singleLabel"
                                  slot-scope="{ option }"
                                >
                                  <strong>{{ option.key }}</strong>
                                </template>
                              </multiselect>
                            </b-form-group>
                          </div>
                          <div class="col-md-1 col-2">
                            <input
                              type="button"
                              class="btn btn-primary btn-block inner"
                              value="Delete"
                              @click="deleteAPI(index)"
                            />
                          </div>
                        </div>
                        <input
                          type="button"
                          class="btn btn-success inner"
                          value="Add more API"
                          @click="AddAPI"
                        />
                      </div>
                    </div>
                    <div class="form-group mb-4 text-center">
                      <div class="button-items">
                        <button type="submit" class="btn btn-primary">
                          Save
                        </button>
                        <button
                          type="button"
                          class="btn btn-secondary"
                          @click="onCancel()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </form>
                </validationObserver>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Vue from "vue";
import NumberInputSpinner from '@/components/number-input-spinner'
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import permissionService from "@/helpers/service/permission-provider";
import { eventBus } from "@/main.js";
import { applicationComputed } from "@/state/helpers";

export default {
  page: {
    title: "Create New Permission",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, NumberInputSpinner },
  data() {
    return {
      isProcessing: false,
      id: "",
      action: "new",
      title: "Create New",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Permission",
          href: "/permissions",
        },
        {
          text: "Create New",
          active: true,
        },
      ],
      createModel: {
        version: 1,
        area: "",
        controller: "",
        method: "",
        action: "",
        display_name: "",
        display_name_old: "",
        type: "",
        status: "Active",
        create_flag: "",
      },
      apisData: [
        {
          id: 1,
          api_url: "",
          display_name_field: { key: "Summary", value: "summary" },
        },
      ],
      display_name_field_options: [
        { key: "Summary", value: "Summary" },
        { key: "Operation Id", value: "OperationId" },
      ],
      isDuplicate: false,
    };
  },
  computed: {
    ...applicationComputed,
    isVersion() {
      return (
        this.$validate.isObjectValid(this.createModel) &&
        this.$validate.isValid(this.createModel.version)
      );
    },
  },
  created: function () {
    this.id = this.$route.params.id;
    if (this.id === "new") {
      this.action = "new";
      this.title = "Create";
    } else {
      this.action = "edit";
      this.title = "Edit";
    }
  },
  mounted: function () {
    if (this.action === "edit") {
      this.getDetail();
    }
  },
  methods: {
    async getDetail() {
      let result = await permissionService.getPermissionAsync(
        this.GET_APPLICATION_SELECTED.id,
        this.id
      );
      if (result.status === 200) {
        this.createModel = result.data;
        if (this.isVersion) {
          this.createModel.version = parseInt(this.createModel.version);
        }
        this.createModel.display_name_old = result.data.display_name;
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    async onInput(newValue) {

      if (this.isProcessing) return; // ป้องกันการเรียกซ้ำ
      this.isProcessing = true;

      console.log("New Value from event:", newValue);

      // รอ Vue อัปเดตค่าเสร็จ
      await this.$nextTick();

      // console.log("Updated Value in Vue:", this.createModel.version,this.$refs.addPermissionForm.version);
      // this.createModel.version = newValue
      // หน่วงเวลาสั้น ๆ เพื่อป้องกัน Trigger ซ้ำ
      setTimeout(() => {
        this.isProcessing = false;
      }, 100);
    },
    async onSubmitManual() {

      await this.$refs.addPermissionForm.validate().then(async (result) => {
        console.log('this.action',this.action);
        
        if (result) {
          if (this.action === "new") {
            let result = await permissionService.createPermissionAsync(
              this.GET_APPLICATION_SELECTED.id,
              this.createModel
            );
            if (result.status === 201) {
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              this.$router.push({
                path: "/permissions",
              });
            } else {
              var obj = result.response.data.errors;
              var ex = obj[Object.keys(obj)[0]][0];
              eventBus.$emit("error-modal", ex);
            }
          } else {
            let result = await permissionService.updatePermissionAsync(
              this.GET_APPLICATION_SELECTED.id,
              this.id,
              this.createModel
            );

            
            if (result.status == 204) {
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              this.$router.push({
                path: "/permissions",
              });
            } else {
              var obj2 = result.response.data.errors;
              eventBus.$emit("error-modal", obj2[Object.keys(obj2)[0]][0]);
            }
          }
        }
      });
    },
    resetForm() {
      // this.clearForm()
      this.$refs.syncPermissionForm.reset()
      this.createModel.version = 1;
      this.clearForm()

      console.log('this.createModel.version',this.createModel.version,this.$refs.syncPermissionForm);
      
    },
    async onSubmitSync() {
      this.$refs.syncPermissionForm.validate().then(async (result) => {
        if (result) {
          // var apis = this.apisData.map((p) => p.api_url);
          var swaggers = [];
          this.apisData.forEach((element) => {
            swaggers.push({
              url: element.api_url,
              display_name_field: element.display_name_field.value,
            });
          });

          let result = await permissionService.bulkPermissionAsync(
            this.GET_APPLICATION_SELECTED.id,
            { swaggers: swaggers }
          );
          if (result.status === 201) {
            Vue.swal({
              position: "top-end",
              icon: "success",
              title: "Your work has been saved",
              showConfirmButton: false,
              timer: 1500,
            });
            this.$router.push({
              path: "/permissions",
            });
          } else {
            var obj = result.response.data.errors;
            var ex = obj[Object.keys(obj)[0]][0];
            eventBus.$emit("error-modal", ex);
          }
        }
      });
    },
    onCancel() {
      this.$router.push({
        path: "/permissions",
      });
    },
    async onValidateDisplayname() {
      if (
        !(
          this.createModel.display_name.trim() === "" ||
          this.createModel.display_name.trim() === null ||
          this.createModel.display_name.trim() === undefined
        )
      ) {
        if (
          this.action === "edit" &&
          this.createModel.display_name_old ==
            this.createModel.display_name.trim()
        ) {
          return;
        }
        let params = new URLSearchParams();
        params.append("display_name", this.createModel.display_name.trim());
        if (this.action !== "new") {
          params.append("id", this.id);
        }
        let result = await permissionService.headPermissionAsync(
          this.GET_APPLICATION_SELECTED.id,
          params
        );
        if (result.status === 200) {
          this.isDuplicate = true;
        } else if (result.response.status === 404) {
          this.isDuplicate = false;
        } else {
          if (result.response.data.message) {
            eventBus.$emit("error-modal", result.response.data.message);
          } else {
            eventBus.$emit("error-modal", "Bad request: Unkonw error");
          }
        }
      }
    },
    clearForm() {
      this.createModel = {
        version: 1,
        area: "",
        controller: "",
        method: "",
        action: "",
        display_name: "",
        type: "",
        status: "Active",
        create_flag: "",
      };
    },
    deleteAPI(index) {
      this.apisData.splice(index, 1);
    },
    AddAPI() {
      let _id = this.apisData.length + 1;
      this.apisData.push({
        id: _id,
        api_url: "",
        display_name_field: { key: "Summary", value: "summary" },
      });
    },
  },
};
</script>
